<template>
    <strong v-html="headline"></strong>
</template>

<script>
    export default {
        props: ['logLine'],

        computed: {
            headline() {
                if (this.logLine.event === 'company-created') {
                    return 'Company Created'
                }

                if (this.logLine.event === 'company-updated') {
                    return 'Company Updated'
                }

                if (this.logLine.event === 'person-created') {
                    return 'Person Created'
                }

                if (this.logLine.event === 'person-updated') {
                    return 'Person Updated'
                }

                if (this.logLine.event === 'invoice-created') {
                    return 'Invoice Created'
                }

                if (this.logLine.event === 'invoice-drafted') {
                    return 'Invoice Drafted'
                }

                if (this.logLine.event === 'invoice-paid') {
                    return 'Invoice Paid'
                }

                if (this.logLine.event === 'subscription-created') {
                    return 'Subscription Created'
                }

                if (this.logLine.event === 'subscription-updated') {
                    return 'Subscription Updated'
                }

                if (this.logLine.event === 'order-created') {
                    return 'Order Created'
                }

                if (this.logLine.event === 'order-updated') {
                    return 'Order Updated'
                }

                if (this.logLine.event === 'order-confirmation-created') {
                    return 'Order Confirmation Created'
                }

                if (this.logLine.event === 'opportunity-created') {
                    return 'Opportunity Created'
                }

                if (this.logLine.event === 'opportunity-updated') {
                    return 'Opportunity Updated'
                }

                if (this.logLine.event === 'opportunity-closed') {
                    return 'Opportunity Closed'
                }

                if (this.logLine.event === 'opportunity-converted-to-order') {
                    return 'Opportunity Converted'
                }

                if (this.logLine.event === 'opportunity-converted-to-subscription') {
                    return 'Opportunity Converted'
                }

                if (this.logLine.event === 'email-created') {
                    return 'Email Created'
                }

                if (this.logLine.event === 'reminder-created') {
                    let content = 'Reminder: ' + this.$options.filters.datetime(this.logLine.subject.remind_at)

                    if (this.logLine.subject.resolved_at) {
                        content = content + '&nbsp;<span class="label label-success">Resolved</span>'
                    }

                    return content
                }

                if (this.logLine.event === 'comment-created') {
                    return 'Comment'
                }

                return 'Unknown Event'
            }
        }
    }
</script>
